import { render, staticRenderFns } from "./SkillingTopic.vue?vue&type=template&id=32a80e35&"
import script from "./SkillingTopic.vue?vue&type=script&lang=js&"
export * from "./SkillingTopic.vue?vue&type=script&lang=js&"
import style0 from "./SkillingTopic.vue?vue&type=style&index=0&id=32a80e35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports